import React, { Component } from 'react';
import { connect } from 'react-redux';
import './index.scss';

class CommonTitle extends Component {

  constructor(props) {
    super(props);
    this.state = {
      title: '技术专家'
    }
  }

  componentDidMount() {
    const { title } = this.props;
    this.setState({
      title
    })
  }

  render() {

    const { title } = this.state
    return (
      <div className="common-title">
        <h2 className="title">{title}</h2>
        <span className="line"></span>
      </div>
    )
  }
}

export default connect(null, null)(CommonTitle);
